export default __webpack_public_path__ + "static/media/36.f1b48e63.jpg";